module.exports = __webpack_public_path__ + "static/media/no-img2.8642922d.png";